<template>
  <HrPageLayout
    title="HR Requests to Public Service Board"
    :breadcrumb-items="[{ label: 'Home', route: '/dashboard' }, { label: 'Board & Compliance' }, { label: 'HR Requests to PSB' }]"
  >
    <div class="director-module">
      <div class="actions-row">
        <button type="button" class="hr-btn hr-btn-primary" @click="openRequestModal">New request</button>
        <select v-model="filterStatus" @change="loadRequests">
          <option value="">All statuses</option>
          <option value="Draft">Draft</option>
          <option value="Submitted">Submitted</option>
          <option value="Approved">Approved</option>
        </select>
      </div>
      <div class="table-wrap card-section">
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th>Type</th>
              <th>Department</th>
              <th>Title</th>
              <th>Submitted by</th>
              <th>Status</th>
              <th>Establishment</th>
              <th>Financial cost (KES)</th>
              <th>Document</th>
              <th>Board approved</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in requests" :key="r.id">
              <td>{{ r.request_type }}</td>
              <td>{{ r.department_name }}</td>
              <td>{{ r.title }}</td>
              <td>{{ r.submitted_by || '–' }}</td>
              <td>{{ r.status }}</td>
              <td>{{ r.establishment_compliant === 1 ? 'Yes' : r.establishment_compliant === 0 ? 'No' : '–' }}</td>
              <td>{{ formatNum(r.financial_cost) }}</td>
              <td>
                <button v-if="r.document_attachment" type="button" class="hr-btn hr-btn-sm hr-btn-info" @click="viewAttachment(r)">View PDF</button>
                <span v-else>–</span>
              </td>
              <td>{{ r.board_approved_at ? 'Yes' : 'No' }}</td>
              <td>
                <button v-if="r.status === 'Draft'" type="button" class="hr-btn hr-btn-sm" @click="editRequest(r)">Edit</button>
                <button v-if="r.status === 'Draft'" type="button" class="hr-btn hr-btn-sm hr-btn-success" @click="submitRequest(r.id)">Submit</button>
                <button v-if="r.status === 'Submitted'" type="button" class="hr-btn hr-btn-sm" @click="openApproveModal(r)">Approve</button>
              </td>
            </tr>
            <tr v-if="!requests.length"><td colspan="10" class="text-muted">No requests</td></tr>
          </tbody>
        </table>
      </div>

      <div v-if="showRequestModal" class="modal-overlay" @click.self="showRequestModal = false">
        <div class="modal-card modal-card-wide">
          <h3>{{ editingRequest ? 'Edit' : 'New' }} HR request</h3>
          <div class="modal-form-grid">
          <div class="form-group">
            <label>Request type</label>
            <input v-model="requestForm.request_type" type="text" placeholder="e.g. Recruitment, Promotion">
          </div>
          <div class="form-group">
            <label>Department</label>
            <select v-model="requestForm.department_id">
              <option value="">Select</option>
              <option v-for="d in departments" :key="d.id" :value="d.departmentID || d.id">{{ d.departmentName }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Title</label>
            <input v-model="requestForm.title" type="text" required>
          </div>
          <div class="form-group">
            <label>Description</label>
            <textarea v-model="requestForm.description" rows="3"></textarea>
          </div>
          <div class="form-group">
            <label>Establishment compliant</label>
            <select v-model.number="requestForm.establishment_compliant">
              <option :value="null">–</option>
              <option :value="1">Yes</option>
              <option :value="0">No</option>
            </select>
          </div>
          <div class="form-group">
            <label>Financial cost (KES)</label>
            <input v-model.number="requestForm.financial_cost" type="number" step="0.01">
          </div>
          <div class="form-group">
            <label>Cost notes</label>
            <input v-model="requestForm.cost_notes" type="text">
          </div>
          <div class="form-group span2">
            <label>Upload supporting document (PDF)</label>
            <input ref="pdfInput" type="file" accept=".pdf,application/pdf" @change="onPdfSelected">
            <small class="text-muted">PDF only.</small>
            <div v-if="requestForm.document_attachment" style="margin-top:4px;">
              Current: <button type="button" class="hr-btn hr-btn-sm hr-btn-info" @click="viewAttachment(requestForm)">View PDF</button>
            </div>
          </div>
          </div>
          <div class="modal-actions">
            <button type="button" class="hr-btn hr-btn-secondary" @click="showRequestModal = false">Cancel</button>
            <button type="button" class="hr-btn hr-btn-primary" :disabled="saving" @click="saveRequest">Save</button>
          </div>
        </div>
      </div>

      <div v-if="showApproveModal" class="modal-overlay" @click.self="showApproveModal = false">
        <div class="modal-card">
          <h3>Board approval</h3>
          <div class="form-group">
            <label>Remarks</label>
            <textarea v-model="approveForm.board_remarks" rows="3"></textarea>
          </div>
          <div class="modal-actions">
            <button type="button" class="hr-btn hr-btn-secondary" @click="showApproveModal = false">Cancel</button>
            <button type="button" class="hr-btn hr-btn-primary" :disabled="saving" @click="approveRequest">Approve</button>
          </div>
        </div>
      </div>
    </div>
  </HrPageLayout>
</template>

<script>
import HrPageLayout from "@/components/hrActions/HrPageLayout.vue";
import { execute, executeDownload, authUrl, toast } from "@/api";

export default {
  name: "HrPsbRequests",
  components: { HrPageLayout },
  data() {
    return {
      requests: [],
      departments: [],
      filterStatus: "",
      showRequestModal: false,
      showApproveModal: false,
      editingRequest: null,
      saving: false,
      requestForm: {
        id: null,
        request_type: "",
        department_id: "",
        department_name: "",
        title: "",
        description: "",
        establishment_compliant: null,
        financial_cost: null,
        cost_notes: "",
        document_attachment: "",
        status: "Draft"
      },
      approveForm: { id: null, board_remarks: "" },
      selectedPdfFile: null
    };
  },
  created() {
    this.getDepartments();
    this.loadRequests();
  },
  methods: {
    getDepartments() {
      const fd = new FormData();
      fd.append("function", "getDepartments");
      execute(fd, authUrl).then((res) => {
        if (res.data && res.data.success && res.data.data && res.data.data.departments)
          this.departments = res.data.data.departments;
      }).catch(() => {});
    },
    loadRequests() {
      const fd = new FormData();
      fd.append("function", "getHrPsbRequests");
      execute(fd, authUrl).then((res) => {
        let list = (res.data && res.data.success && res.data.data && res.data.data.requests) ? res.data.data.requests : [];
        if (this.filterStatus) list = list.filter((r) => r.status === this.filterStatus);
        this.requests = list;
      }).catch(() => { this.requests = []; });
    },
    formatNum(n) {
      if (n == null) return "–";
      return Number(n).toLocaleString("en-KE", { minimumFractionDigits: 2 });
    },
    openRequestModal() {
      this.editingRequest = null;
      this.selectedPdfFile = null;
      this.requestForm = { id: null, request_type: "", department_id: "", department_name: "", title: "", description: "", establishment_compliant: null, financial_cost: null, cost_notes: "", document_attachment: "", status: "Draft" };
      this.$nextTick(() => { if (this.$refs.pdfInput) this.$refs.pdfInput.value = ""; });
      this.showRequestModal = true;
    },
    editRequest(r) {
      this.editingRequest = r;
      this.selectedPdfFile = null;
      this.requestForm = { id: r.id, request_type: r.request_type || "", department_id: r.department_id || "", department_name: r.department_name || "", title: r.title || "", description: r.description || "", establishment_compliant: r.establishment_compliant, financial_cost: r.financial_cost, cost_notes: r.cost_notes || "", document_attachment: r.document_attachment || "", status: r.status || "Draft" };
      this.$nextTick(() => { if (this.$refs.pdfInput) this.$refs.pdfInput.value = ""; });
      this.showRequestModal = true;
    },
    onPdfSelected(e) {
      const file = e?.target?.files?.[0] || null;
      if (!file) { this.selectedPdfFile = null; return; }
      const isPdf = file.type === "application/pdf" || /\.pdf$/i.test(file.name || "");
      if (!isPdf) {
        this.selectedPdfFile = null;
        if (this.$refs.pdfInput) this.$refs.pdfInput.value = "";
        toast.error("Only PDF is allowed");
        return;
      }
      this.selectedPdfFile = file;
    },
    saveRequest() {
      if (!this.requestForm.title) return;
      const d = this.departments.find((x) => (x.departmentID || x.id) == this.requestForm.department_id);
      this.requestForm.department_name = d ? d.departmentName : "";
      this.saving = true;
      const fd = new FormData();
      fd.append("function", "saveHrPsbRequest");
      Object.keys(this.requestForm).forEach((k) => fd.append(k, this.requestForm[k] == null ? "" : this.requestForm[k]));
      if (this.selectedPdfFile) fd.append("document_file", this.selectedPdfFile);
      execute(fd, authUrl).then((res) => {
        this.saving = false;
        if (res.data && res.data.success) {
          this.showRequestModal = false;
          this.loadRequests();
        } else toast.error(res.data && res.data.message ? res.data.message : "Save failed");
      }).catch(() => { this.saving = false; });
    },
    async viewAttachment(r) {
      const id = r?.id || this.requestForm?.id;
      if (!id) return;
      try {
        const fd = new FormData();
        fd.append("function", "downloadHrPsbRequestAttachment");
        fd.append("id", String(id));
        const res = await executeDownload(fd, authUrl);
        const blob = res?.data;
        if (!(blob instanceof Blob)) return toast.error("Could not open attachment");
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      } catch (e) {
        toast.error("Could not open attachment");
      }
    },
    submitRequest(id) {
      const fd = new FormData();
      fd.append("function", "submitHrPsbRequest");
      fd.append("id", id);
      execute(fd, authUrl).then((res) => {
        if (res.data && res.data.success) this.loadRequests();
        else alert(res.data && res.data.message ? res.data.message : "Submit failed");
      }).catch(() => {});
    },
    openApproveModal(r) {
      this.approveForm = { id: r.id, board_remarks: "" };
      this.showApproveModal = true;
    },
    approveRequest() {
      if (!this.approveForm.id) return;
      this.saving = true;
      const fd = new FormData();
      fd.append("function", "approveHrPsbRequest");
      fd.append("id", this.approveForm.id);
      fd.append("board_remarks", this.approveForm.board_remarks);
      execute(fd, authUrl).then((res) => {
        this.saving = false;
        if (res.data && res.data.success) {
          this.showApproveModal = false;
          this.loadRequests();
        } else {
          alert(res.data && res.data.message ? res.data.message : "Approval failed");
        }
      }).catch(() => { this.saving = false; });
    }
  }
};
</script>

<style scoped>
.director-module { padding: 0 0 24px; }
.actions-row { display: flex; gap: 12px; margin-bottom: 16px; align-items: center; }
.card-section { background: #fff; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); padding: 16px; }
.table-wrap { overflow-x: auto; }
.table { width: 100%; font-size: 13px; }
.modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.4); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.modal-card { background: #fff; border-radius: 8px; padding: 24px; max-width: 520px; width: 90%; max-height: 90vh; overflow-y: auto; }
.modal-card-wide { max-width: 760px; }
.modal-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.span2 { grid-column: 1 / -1; }
.form-group { margin-bottom: 12px; }
.form-group label { display: block; font-weight: 600; margin-bottom: 4px; }
.modal-actions { display: flex; gap: 8px; justify-content: flex-end; margin-top: 16px; }
.text-muted { color: #6c757d; }
</style>
